import React, { useEffect, useState } from "react";
import { Row, Col, Button } from "antd";
import { useNavigate } from "react-router-dom";
import "./index.less";
import LocationsManagerTable from "./locationsManagerTable";
import { useDispatch, useSelector } from "react-redux";
import { setLocationDetailsIsEdit, fetchLocations, fetchAllLocations } from "./redux/actions";
import { PlusOutlined } from "@ant-design/icons";
import ExportLocations from "./exportLocations";
import Tooltip from "../../components/tooltip-Custom";

const LocationManager = () => {
  const tableRef = React.useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.authReducer);
  const [canUpdate, setCanUpdate] = useState(false);

  useEffect(() => {
    if (user?.permissions?.locations?.add_edit) {
      setCanUpdate(true);
    }
  }, [user]);

  // We'll let the table component handle fetching locations
  useEffect(() => {
    // Clean up the location state when component unmounts
    return () => {
      dispatch({ type: 'LOCATION_DETAIL_CLEANUP_FUNC' });
    };
  }, [dispatch]);

  return (
    <div className="page-top-div">
      <span className="text-span">Locations</span>
      <Row className="production-manager-parent-row card-container">
        <Col span={24} className="heading-col">
          <Row align="middle" gutter={[50, 0]} justify="space-between">
            <Col>
              <Row align="middle" gutter={[80, 0]}>
                <Col>
                  <div>
                    <span className="heading-span">Locations Manager</span>
                  </div>
                </Col>
                <Col>
                  {canUpdate && (
                    <Button
                      onClick={() => {
                        // Use the new in-place editing functionality
                        if (tableRef.current) {
                          tableRef.current.addNewLocation();
                        }
                      }}
                      className="add-user-btn"
                      icon={<PlusOutlined />}
                      size="middle"
                      style={{
                        width: "105%",
                        background: "white",
                        color: "#f25003",
                        border: "1px solid #f25003",
                        fontWeight: 600,
                        fontSize: "13px",
                        lineHeight: "15px",
                        height: "32px",
                        borderRadius: "2px"
                      }}
                    >
                      LOCATION
                    </Button>
                  )}
                </Col>
              </Row>
            </Col>
            <Col>
              {user?.permissions?.locations?.export && (
                <Tooltip text="Export">
                  <ExportLocations />
                </Tooltip>
              )}
            </Col>
          </Row>
        </Col>

        <Col span={24}>
          <LocationsManagerTable ref={tableRef} canUpdate={canUpdate} canDelete={user?.permissions?.locations?.delete || false} />
        </Col>
      </Row>
    </div>
  );
};

export default LocationManager;
